import React from "react";
import { getThHeaderStyle } from "../../styles/attendanceStyles";
import { useVisibleColumns } from "../../../../hooks/useVisibleColumns";

const TableHeader = ({ theme, isRTL, t }) => {
  const thStyle = getThHeaderStyle(theme);

  // ✅ Admin-level column visibility (hiddenColumns registry). Must stay in
  // sync with the same keys gated in TableRow.jsx. Bypassed roles
  // (admin/superadmin) always see every column — the hook handles that.
  const attendanceColumns = [
    { key: "employeeName" },
    { key: "date" },
    { key: "checkIn" },
    { key: "checkOut" },
    { key: "hoursWorked" },
    { key: "status" },
    { key: "overtime" },
    { key: "tardiness" },
    { key: "client" },
    { key: "actions" },
  ];
  const visibleColumns = useVisibleColumns("attendance", "attendanceTable", attendanceColumns);
  const showColumn = (key) => visibleColumns.some((col) => col.key === key);

  return (
    <thead>
      <tr>
        {/* <th style={{ ...thStyle, borderTopLeftRadius: isRTL ? "0px" : "12px", borderTopRightRadius: isRTL ? "12px" : "0px" }}>
          {t.employeeID}
        </th> */}
        {showColumn("employeeName") && (
          <th style={{ ...thStyle, verticalAlign: isRTL ? 'right' : 'left',
        justifyContent: isRTL ? 'right' : 'left',
        textAlign: isRTL ? 'right' : 'left', }}>
            {t.employeeName}
          </th>
        )}
        {showColumn("date") && <th style={thStyle}>{t.date}</th>}
        {showColumn("checkIn") && <th style={thStyle}>{t.checkIn}</th>}
        {showColumn("checkOut") && <th style={thStyle}>{t.checkOut}</th>}
        {showColumn("hoursWorked") && <th style={thStyle}>{t.hoursWorked}</th>}
        {showColumn("status") && <th style={thStyle}>{t.status}</th>}
        {showColumn("overtime") && <th style={thStyle}>{t.overtime}</th>}
        {showColumn("tardiness") && <th style={thStyle}>{t.tardiness}</th>}
        {showColumn("client") && <th style={thStyle}>{t.client}</th>}
        {showColumn("actions") && (
          <th style={{ ...thStyle, borderTopLeftRadius: isRTL ? "12px" : "0px", borderTopRightRadius: isRTL ? "0px" : "12px" }}>
            {t.actions}
          </th>
        )}
      </tr>
    </thead>
  );
};

export default TableHeader;
